<ng-template #tooltipContent let-entry="entry">
  <div class="info-description">
    @if (configs.maxFiles) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'dragAndDrop.maxFiles' | cxTranslate }}</span>
        <span class="value">{{ configs.maxFiles }}</span>
      </p>
    }

    @if (configs.maxFileSize) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'dragAndDrop.maxFileSize' | cxTranslate }}</span>
        <span class="value">{{ this.dragAndDropService.formatFileSize(configs.maxFileSize) }}</span>
      </p>
    }

    @if (configs.allowedFileTypes) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'dragAndDrop.formats' | cxTranslate }}</span>
        <span class="value">{{ configs.allowedFileTypes }}</span>
      </p>
    }
  </div>
</ng-template>

<div class="container-drag-and-drop">
  <div
    class="drag-drop-area"
    [ngClass]="{ 'is-dragging': isDragging }"
    (dragover)="handlerDragOver($event)"
    (dragleave)="handlerLeave($event)"
    (drop)="handlerDrop($event)"
    >
    <input #input type="file" [multiple]="configs.maxFiles > 1" class="d-none" (change)="handlerChange(input)" />

    @if (configs) {
      <div class="rules">
        <ng-container *limitUp="DEVICE_SIZE.DESKTOP">
          <span class="icon material-symbols-outlined" [pTooltip]="tooltip"> info </span>
        </ng-container>

        <button class="btn-tooltip" [pTooltip]="tooltip" tooltipEvent="focus" *smallerThan="DEVICE_SIZE.DESKTOP">
          <span class="icon material-symbols-outlined"> info </span>
        </button>

        <ng-template #tooltip>
          <ng-container *ngTemplateOutlet="tooltipContent"> </ng-container>
        </ng-template>
      </div>
    }

    @if (files?.length) {
      <button type="button" class="btn btn-outline-danger btn-clear" (click)="clear()">
        <span class="material-symbols-outlined d-flex">{{ 'dragAndDrop.delete' | cxTranslate }}</span>
      </button>
    }

    <div class="box-icon w-100">
      <span class="material-symbols-outlined d-flex text-primary"> cloud_upload </span>
    </div>

    <p class="w-100 text-center m-t-20">
      <span>
        {{ 'dragAndDrop.dragAndDropFiles' | cxTranslate }}
        <span class="text-primary ff-bold c-pointer" (click)="input.click()" (keypress)="input.click()" [attr.tabindex]="0">{{ 'dragAndDrop.here' | cxTranslate }}</span>
        {{ 'dragAndDrop.toUpload' | cxTranslate }}
      </span>
    </p>
  </div>

  @if (files?.length) {
    <ul class="file-list">
      @for (file of files; track file) {
        <li>
          <span>
            {{ file.name }}
          </span>
          <button type="button" class="btn-link d-flex btn-remove-file" (click)="removeFile(file)">
            <span class="material-symbols-outlined text-danger">{{ 'dragAndDrop.close' | cxTranslate }}</span>
          </button>
        </li>
      }
    </ul>
  }
</div>